import { Breadcrumb, Dropdown } from 'antd';
import { memo, useMemo } from 'react';
import { Link, useLocation, useMatches } from 'react-router-dom';
import { getPath } from 'routes/router-paths';
import { type TAppUIMatch } from 'shared/components/AppBreadcrumbs/types';
import {
  AltArrowDownOutlineIcon,
  Home2OutlineIcon,
} from 'shared/components/AppIcon';

export const AppBreadcrumbs = memo(() => {
  const matches = useMatches() as TAppUIMatch[];
  const location = useLocation();

  const isHomePage = location.pathname === getPath('dashboardPage');

  const foundMatch = [...matches]
    .reverse()
    .find(match => match.handle?.breadcrumbs != null);

  const foundParams = foundMatch?.params as
    | Record<string, string | undefined>
    | undefined;

  const searchParams = new URLSearchParams(location.search);

  const rawBreadcrumbs = foundMatch?.handle?.breadcrumbs;

  const resolvedBreadcrumbs =
    rawBreadcrumbs === null || rawBreadcrumbs === undefined
      ? undefined
      : typeof rawBreadcrumbs === 'function'
        ? rawBreadcrumbs(foundParams ?? {}, searchParams)
        : rawBreadcrumbs;

  const breadcrumbs = useMemo(
    () =>
      resolvedBreadcrumbs?.map(crumb => ({
        title: crumb.path ? (
          <Link to={crumb.path}>{crumb.title}</Link>
        ) : (
          crumb.title
        ),
      })),
    [resolvedBreadcrumbs]
  );

  if (isHomePage)
    return (
      <h1 className="text-2xl font-semibold max-768:text-xl">Dashboard</h1>
    );
  if (!breadcrumbs || breadcrumbs.length === 0) return null;

  const mobileDropdownItems = [
    {
      key: 'home',
      label: (
        <Link to={getPath('dashboardPage')}>
          <div className="flex items-center gap-2">
            <Home2OutlineIcon className="size-4" />
            <span>Trang chủ</span>
          </div>
        </Link>
      ),
    },
    ...(resolvedBreadcrumbs?.slice(0, -1).map((crumb, index) => ({
      key: index.toString(),
      label: crumb.path ? (
        <Link to={crumb.path}>{crumb.title}</Link>
      ) : (
        crumb.title
      ),
    })) ?? []),
  ];

  const lastCrumb = resolvedBreadcrumbs?.[resolvedBreadcrumbs.length - 1];

  return (
    <>
      <Breadcrumb
        className="max-768:hidden [&_ol]:list-none"
        separator={<span className="font-bold text-[#5a6a78]">/</span>}
        items={[
          {
            title: (
              <Link to={getPath('dashboardPage')}>
                <Home2OutlineIcon className="size-4 text-[#5a6a78]" />
              </Link>
            ),
          },
          ...breadcrumbs,
        ]}
      />
      <div className="hidden max-768:block">
        <Dropdown menu={{ items: mobileDropdownItems }} trigger={['click']}>
          <div className="flex cursor-pointer items-center gap-1 text-xs font-medium">
            {lastCrumb?.title}
            <AltArrowDownOutlineIcon className="size-4" />
          </div>
        </Dropdown>
      </div>
    </>
  );
});
